import LinearProgress from "@mui/material/LinearProgress";
import React from "react";

import scss from "./UiLoader.module.scss";

export default ({visible}) => <LinearProgress className={`${scss.UiLoader} ${(!visible ? scss.UiLoaderInvisible : "")}`} />;
